import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { BRAND } from '../config/brand';

const Login = () => {
  const { loginData, setLoginData, login, isLoading, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  const handleSubmit = async (e) => {
    const result = await login(e);
    if (result?.success) {
      navigate(result.must_change_password ? '/change-password' : '/dashboard', { replace: true });
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-100">
      <form
        onSubmit={handleSubmit}
        className="bg-white p-8 rounded-xl shadow-md w-full max-w-md"
      >
        <h1 className="text-2xl font-semibold text-teal-800 mb-1">{BRAND.companyName}</h1>
        <p className="text-slate-500 text-sm mb-1">{BRAND.tagline}</p>
        <p className="text-slate-600 mb-6">Admin sign in</p>
        <label className="block text-sm font-medium text-slate-700 mb-1">Email</label>
        <input
          type="email"
          className="w-full border border-slate-300 rounded-lg px-3 py-2 mb-4"
          value={loginData.email}
          onChange={(e) => setLoginData({ ...loginData, email: e.target.value })}
          required
        />
        <label className="block text-sm font-medium text-slate-700 mb-1">Password</label>
        <input
          type="password"
          className="w-full border border-slate-300 rounded-lg px-3 py-2 mb-6"
          value={loginData.password}
          onChange={(e) => setLoginData({ ...loginData, password: e.target.value })}
          required
        />
        <button
          type="submit"
          disabled={isLoading}
          className="w-full bg-teal-700 text-white py-2 rounded-lg hover:bg-teal-800 disabled:opacity-50"
        >
          {isLoading ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
    </div>
  );
};

export default Login;
